import React from 'react';
import styles from './CtgAnnotationComponent.module.css';
export var CtgAnnotationComponent = function (props) {
    var renderedElement = null;
    if (props.ctgAnnotation && props.ctgAnnotation.trim().length) {
        renderedElement = (React.createElement("div", { className: styles.container, "data-test-id": 'ctg-annotation' },
            React.createElement("div", { className: styles.main },
                React.createElement("span", { className: styles.ctg }, props.ctgAnnotation))));
    }
    return renderedElement;
};
